import React, { Component } from "react";
import { withRouter } from "react-router-dom";
class Header extends Component {
// eslint-disable-next-line  
constructor(props) {
    super(props);
  }
  render() {
    return (
      <>
        <h2 style={{wordBreak: "break-word"}} className="pageTitle">{this.props.title}</h2>
      </>
    );
  }
}

export default withRouter(Header);
